import ICustomerInvoiceTable from "@/Interfaces/CustomersAndContracts/ICustomerInvoiceTable";
import { extractNonArraysFromObj } from '@/services/helpers/ObjectHelper';
import DateIgnoreTime from "@/types/DateIgnoreTime";

export default class CustomerInvoiceTable implements ICustomerInvoiceTable {
    INVOICE_ID: string;
    ISSUE_DATE: DateIgnoreTime;
    DUE_DATE: DateIgnoreTime;
    
    constructor(data: ICustomerInvoiceTable) {
        Object.assign(this,extractNonArraysFromObj(data));
        this.INVOICE_ID = data.INVOICE_ID;
        this.ISSUE_DATE=new DateIgnoreTime(data.ISSUE_DATE);
        this.DUE_DATE=new DateIgnoreTime(data.DUE_DATE);
    }
}
